export default __webpack_public_path__ + "static/media/upload.d2aab627.svg";